import { useContext, useRef } from 'react';
import TickGreen from '../../../../Assets/Modals/TickGreen.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, fetchInventoryProducts, setSelectedProduct, removeProductFromInventory } from '../../../../Features/inventoryManagementSlice';
import { deleteProduct } from '../../../../lib/utils/apiCalls';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';
import { toast } from 'react-toastify';
import { InventoryManagementContext } from '../../../../Context/InventoryManagementContext';

function DeleteConfirmation() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
        dispatch(setSelectedProduct({}));
    });

    const selectedProduct = useSelector((state) => state.inventoryManagement.selectedProduct);

    const { selectedProducts, setSelectedProducts } = useContext(InventoryManagementContext);

    const handleCancelClick = () => {
        dispatch(closeModal());
        dispatch(setSelectedProduct({}));
    }

    const handleDeleteClick = async () => {
        if (selectedProducts.length > 0) {
            const deletePromises = selectedProducts.map(productId => deleteProduct(productId));
            
            const deleteAllPromise = Promise.all(deletePromises);

            toast.promise(
                deleteAllPromise,
                {
                    pending: {
                        render() {
                            return 'Deleting selected products...';
                        },
                        className: 'toast-pending',
                    },
                    success: {
                        render() {
                            return 'Products deleted.';
                        },
                    },
                }
            );

            try {
                await deleteAllPromise;
                dispatch(fetchInventoryProducts());
                dispatch(closeModal());
                setSelectedProducts([]);
            }
            catch (err) {
                showToast('Failed to delete some or all products. Please try again.', 'error');
            }
        }
        else {
            try {
                const response = await deleteProduct(selectedProduct.product.id);

                if (response?.status === 200) {
                    showToast('Product deleted.', 'success');
                    dispatch(removeProductFromInventory(selectedProduct.product.id));
                    dispatch(closeModal());
                }
                else {
                    showToast('Error deleting product.', 'error');
                }
            }
            catch (err) {
                showToast('Error deleting product.', 'error');
            }
        }
    };

    return (
        <div ref={wrapperRef} className="w-[38%] h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-6 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex gap-3">
                <div className="size-12 flex items-center justify-center bg-[#D1FAE5] rounded-full">
                    <div className="size-6 flex items-center justify-center">
                        <img src={TickGreen} alt="" />
                    </div>
                </div>

                <div className="flex flex-col gap-4 w-[calc(100%-48px)]">
                    <div className="flex flex-col gap-2">
                        <h1 className='font-semibold text-[18px] leading-6 text-[#121212]'>Delete Product</h1>

                        <p className='font-normal text-[14px] leading-5 text-[#666666]'>Are you sure you want to delete {selectedProducts.length > 0 ? 'products' : 'this product'}? All product data will be permanently removed from our servers forever. This action cannot be undone.</p>
                    </div>

                    <div className="flex justify-end gap-3 font-medium font-inter">
                        <button onClick={handleCancelClick} className='text-[14px] leading-5 text-[#374151] rounded-md px-[17px] py-[9px] bg-[#FFFFFF] border border-[#D1D5DB] shadow-[0px_1px_2px_0px_#0000000D]'>Cancel</button>

                        <button onClick={handleDeleteClick} className='text-[14px] leading-5 text-[#FFFFFF] rounded-md px-[17px] py-[9px] bg-[#DC2626] shadow-[0px_1px_2px_0px_#0000000D]'>Delete</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirmation;
